/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ active: "false" | "true" }} ActiveInputs */



/**
* | active | output |
* | --- | --- |
* | "false" | "Inactive" |
* | "true" | "Active" |
*
* @param {ActiveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const active = /** @type {((inputs: ActiveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActiveInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.active === "false") return /** @type {LocalizedString} */ (`Inactive`);
		if (i?.active === "true") return /** @type {LocalizedString} */ (`Active`);
		return /** @type {LocalizedString} */ ("active");
	}
	{
		if (i?.active === "false") return /** @type {LocalizedString} */ (`Inactif`);
		if (i?.active === "true") return /** @type {LocalizedString} */ (`Actif`);
		return /** @type {LocalizedString} */ ("active");
	}
});